import { FC, useMemo } from 'react';

import { APTypography } from '@astropay/web-core-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Link } from '@material-ui/core';

import FirebaseService from 'common/services/firebase-service';

import { AstropayIsotip } from 'common/config/assets';
import { translate } from 'common/config/i18n';
import { useDesktopMode } from 'common/helpers/hooks';
import { getMobileOperatingSystem, OS_SYSTEM } from 'common/helpers/utils';

import { useDownloadAppStyles } from './download-app-styles';
import DownloadButton from './download-button/download-button';

export const DownloadApp: FC<{ title?: string; customDescTerm?: string }> = ({
  title = translate('deposit_with_one_touch'),
  customDescTerm,
}) => {
  const classes = useDownloadAppStyles();
  const isDesktopMode = useDesktopMode();
  const system = useMemo(getMobileOperatingSystem, [isDesktopMode]);

  const baseHref = useMemo(async () => {
    return isDesktopMode
      ? (`${process.env.REACT_APP_WEB_BASE_URL}/money` as string)
      : await FirebaseService.createDynamicLink(
          '/loyalty',
          '/loyalty',
          process.env.REACT_APP_WEB_BASE_URL,
          { isi: process.env.REACT_APP_DL_ISI },
        );
  }, [isDesktopMode]);

  const onClick = async () => {
    const href = await baseHref;
    window.location.href = href;
  };

  return (
    <Box className={classes.root}>
      <Box display={'flex'} alignItems={'center'}>
        <Box className={classes.imageIsotipe}>
          <img src={AstropayIsotip} />
        </Box>
        <Box>
          <div className={classes.texts}>
            {!!title && (
              <>
                <APTypography textStyle="Typography_Poppins_13px_SemiBold" color="textPrimary">
                  {title}
                </APTypography>
                <FontAwesomeIcon icon={['far', 'mobile']} className={classes.icon} />
                <br />
              </>
            )}
            <span>
              <Link onClick={onClick}>
                <APTypography
                  textStyle="Typography_Poppins_12px_Regular"
                  className={classes.link}
                  dangerouslySetInnerHTML={{
                    __html: translate(customDescTerm ? customDescTerm : 'deposit_add_balance', {
                      AstroPay_app: `<b>AstroPay app</b>`,
                    }),
                  }}
                />
              </Link>
            </span>
          </div>
        </Box>
      </Box>

      <Box className={classes.buttonsContainer}>
        {system === OS_SYSTEM.UNKNOWN ? (
          <>
            <DownloadButton system={OS_SYSTEM.IOS} size="sm" />
            <DownloadButton system={OS_SYSTEM.ANDROID} size="sm" />
          </>
        ) : (
          <DownloadButton system={system} size={'sm'} />
        )}
      </Box>
    </Box>
  );
};
